
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../node_modules/.11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-06977cf2\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=styles&index=0!./App.vue")

var Component = require("!../../../../../node_modules/.11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../../../../node_modules/.11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-06977cf2\"}!../../../../../node_modules/.11.3.4@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/js/app/demo/component/App.vue
// module id = 42
// module chunks = 0